import { defineComponent as _defineComponent } from 'vue'
import { AxiosError } from "axios";
import { computed, onMounted, reactive, ref } from "vue";

import AppExpandableSection from "@/components/AppExpandableSection.vue";
import AppThemeToggle from "@/components/AppThemeToggle.vue";
import UserDeleteDialog from "@/components/UserDeleteDialog.vue";
import { apiClient } from "@/plugins/api-client";
import {
  UpdateEmailRequest,
  UpdateUserRequest,
  UserResponse,
} from "@/services";
import { useAuthenticationStore } from "@/stores/authentication";
import { useNotificationStore } from "@/stores/notification";
import { usePreferencesStore } from "@/stores/preferences";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileView',
  setup(__props) {

const authStore = useAuthenticationStore();
const notificationStore = useNotificationStore();
const preferencesStore = usePreferencesStore();

// TODO: extract this to component and implement password strength in backend
const password = ref<string>("");
const confirmPassword = ref<string>("");
const oldPassowrd = ref<string>("");
const isVisiblePassword = ref<boolean>(false);

const passwordRules = computed(() => {
  return [
    (v: string) => !!v || "Password is required",
    (v: string) =>
      (v && v.length >= 8) || "Password must be more than 8 characters",
  ];
});

// rules for second password (confirmation password)
const passwordConfirmationRules = computed(() => {
  return [
    confirmPassword.value === password.value || "Passwords must be identical",
  ];
});

const updateUser = reactive<UpdateUserRequest>({ name: "asd" });
const updateEmail = reactive<UpdateEmailRequest>({
  new_email: "test@empty.com",
  password: "nopassword", // pragma: allowlist secret
});
const user = ref<UserResponse>();

async function doUpdateUser() {
  try {
    apiClient.userManagement.updateProfile(updateUser);
    notificationStore.addNotification({
      message: "Profile updated successfully.",
      type: "success",
    });
  } catch (e: unknown) {
    const error = e as AxiosError;
    notificationStore.addNotification({
      message: `Error: ${error.message} `,
      type: "error",
    });
  }
}

async function doPasswordChange() {
  try {
    await apiClient.userManagement.changePw({
      old_password: oldPassowrd.value,
      new_password: password.value,
    });
    notificationStore.addNotification({
      message: "Password was changed successfully!",
      type: "success",
    });
  } catch (e: unknown) {
    const error = e as AxiosError;
    notificationStore.addNotification({
      message: `Error: ${error.message} ${error?.body?.detail}`,
      type: "error",
    });
  }
}

function resetPreferences() {
  preferencesStore.resetPreferences();
  notificationStore.addNotification({
    message: "Your preferences have been successfully reset.",
    type: "success",
  });
}

onMounted(async () => {
  updateUser.name = authStore.user?.name;
  user.value = authStore.user;
  updateEmail.new_email = authStore.user?.email;
});

return { __sfc: true,authStore, notificationStore, preferencesStore, password, confirmPassword, oldPassowrd, isVisiblePassword, passwordRules, passwordConfirmationRules, updateUser, updateEmail, user, doUpdateUser, doPasswordChange, resetPreferences, AppExpandableSection, AppThemeToggle, UserDeleteDialog }
}

})